// show yellow boxes (with additional terms)
var showItemEN = document.getElementById('show-item-en');
if (showItemEN) {
	showItemEN.onclick = function() {
	    document.getElementById('hidden-item-en').style.display = 'block';
	};
}
var showItemPL1 = document.getElementById('show-item-pl-1');
if (showItemPL1) {
	showItemPL1.onclick = function() {
	    document.getElementById('hidden-item-pl-1').style.display = 'block';
	};
}
var showItemPL3 = document.getElementById('show-item-pl-3');
if (showItemPL3) {
	showItemPL3.onclick = function() {
	    document.getElementById('hidden-item-pl-3').style.display = 'block';
	};
}

// show/hide sections in PL 
var termsConsumer = document.getElementById('terms-consumer');
var showItemPLConsumer = document.getElementById('show-item-pl-consumer');
if (showItemPLConsumer) {
	showItemPLConsumer.onclick = function() {
		
		if (termsConsumer.style.display === '') {
			termsConsumer.style.display = 'block';
		}
	    else {
	    	termsConsumer.style.display = '';
	    }
	};
}
var termsEnterprise = document.getElementById('terms-enterprise');
var showItemPLEnterprise = document.getElementById('show-item-pl-enterprise');
if (showItemPLEnterprise) {
	showItemPLEnterprise.onclick = function() {
		
		if (termsEnterprise.style.display === '') {
			termsEnterprise.style.display = 'block';
		}
	    else {
	    	termsEnterprise.style.display = '';
	    }
	};
}

// show section in PL dependant on hash in url
if (location.hash) {
	if (location.hash === "#konsument"){
		termsConsumer.style.display = 'block';
	}
	else if (location.hash === "#przedsiebiorca"){
		termsEnterprise.style.display = 'block';
	}
}